export class PasswordHint {}
